<template>
  <div>
    <b-form novalidate @submit.prevent="onSubmit">
      <b-row>
        <b-col xs="12" md="6">
          <b-card class="mt-3">
            <h4 slot="header">Display</h4>
            <checkbox-control label="Active Station" description="Inactive stations can still be publicly viewed" v-model="item.isActive" :disabled="!isEditable"></checkbox-control>
            <checkbox-control label="Show On Map" description="Sets whether or not to display the station on the map" v-model="item.isOnMap" :disabled="!isEditable"></checkbox-control>
            <select-control label="Display Type" description="Sets what level of allergen information is displayed to public users" v-model="item.displayType" :options="displayTypes" required :disabled="!isEditable"></select-control>
            <text-control label="Name" description="The user-facing name of the station" v-model="item.name" required min-length="2" :disabled="!isEditable"></text-control>
            <text-control label="Name 2" description="An optional, additional name for the station" v-model="item.name2" :disabled="!isEditable"></text-control>
            <text-control label="Display City" description="The city that will appear to end users" v-model="item.displayCity" min-length="2" :disabled="!isEditable"></text-control>
            <p><b-link :to="stationUrl">View Public Page</b-link></p>
          </b-card>
          <b-card class="mt-3">
            <h4 slot="header">Station Details</h4>
              <p>Data in this section will be publicly displayed.</p>
              <text-control label="Station Head Name" v-model="item.headName" :disabled="!isEditable"></text-control>
              <text-control label="Station Head Email" v-model="item.headEmail" :disabled="!isEditable"></text-control>
              <text-control label="Start Year" v-model="item.startYear" :disabled="!isEditable"></text-control>
              <textarea-control label="Notes" description="These notes are not visible to public users" v-model="item.notes" :disabled="!isEditable"></textarea-control>
          </b-card>
        </b-col>
        <b-col xs="12" md="6">
          <b-card class="mt-3">
            <h4 slot="header">Address</h4>
            <checkbox-control label="Display Address" description="If this box isn't checked, the station address won't be displayed publicly" v-model="item.isAddressPublic" :disabled="!isEditable"></checkbox-control>
            <text-control label="Address 1" v-model="item.address1" :disabled="!isEditable"></text-control>
            <text-control label="Address 2" v-model="item.address2" :disabled="!isEditable"></text-control>
            <text-control label="City" description="The physical city of the station" v-model="item.city" min-length="2" :disabled="!isEditable"></text-control>
            <select-control label="State" description="Only required for U.S. locations" v-model="item.state" :options="states" :custom-validation="validateState" :disabled="!isEditable"></select-control>
            <select-control label="Country" v-model="item.country" :options="countries" required :custom-validation="validateCountry" :disabled="!isEditable"></select-control>
            <text-control label="Postal Code" description="For U.S. locations, this is the ZIP code" v-model="item.postalCode" :disabled="!isEditable"></text-control>
          </b-card>
          <b-card class="mt-3" v-if="allowGeocode">
            <h4 slot="header">Map Coordinates</h4>
            <text-control label="Latitude" v-model="item.latitude" :disabled="!isEditable" description="The latitude and longitude determine where the marker for this station will appear on the map."></text-control>
            <text-control label="Longitude" v-model="item.longitude" :disabled="!isEditable"></text-control>
          </b-card>
          <b-card class="mt-3">
            <h4 slot="header">Contact Info</h4>
            <text-control label="Phone Number" v-model="item.phoneNumber" :disabled="!isEditable"></text-control>
            <text-control label="Fax Number" v-model="item.faxNumber" :disabled="!isEditable"></text-control>
            <text-control label="Website URL" v-model="item.website" :disabled="!isEditable"></text-control>
          </b-card>
        </b-col>
      </b-row>

      <b-row class="mt-3">
        <b-col>
          <b-button-toolbar key-nav>
            <b-button-group v-if="isEditable">
              <b-button type="submit" variant="primary">
                <slot name="save"></slot>
              </b-button>
            </b-button-group>
            <b-button-group class="mx-2">
              <b-button type="button" @click="onCancel">Cancel</b-button>
            </b-button-group>
          </b-button-toolbar>
        </b-col>
      </b-row>
      
    </b-form>
  </div>
</template>

<script>
import Constants from '../Common/Constants.js'

export default {
  name: "StationFields",
  props: [
    'item',
    'isEditable',
    'allowGeocode'
  ],
  data() {
    return {
      states: Constants.states,
      countries: Constants.countries,
      displayTypes: [
        { value: null, text: '' },
        { value: 'INDIVIDUAL_ALLERGENS', text: 'Individual Allergens' },
        { value: 'COUNT_TOTALS', text: 'Count Totals' },
        { value: 'SEVERITY_LEVEL', text: 'Severity Level' },
        { value: 'COUNT_TOTALS_AND_SEVERITY_LEVEL', text: 'Count Totals and Severity Level' },
        { value: 'ALL', text: 'Individual Allergens, Count Totals, and Severity Level' }
      ]
    };
  },
  computed: {
    stationUrl: function() {
      if (!this.item)
        return '';
      
      return '/station/' + this.item.id;
    }
  },
  methods: {
    onCancel(evt) {
      this.$emit('cancel');
    },
    onSubmit(evt) {
      // Make sure all the child components are valid
      if (this.$children.every(childComponent => { return typeof(childComponent.isValid) === 'undefined' || childComponent.isValid; }))
        this.$emit('submit');
    },
    validateState() {
      if (this.item.country == 'US' && this.item.state == '')
        return 'State is required when the country is U.S.';
      
      return true;
    },
    validateCountry() {
      if (this.item.country != 'US' && this.item.state != '')
        return 'Country must be U.S. when a state is selected';
      
      return true;
    }
  }
};
</script>